import React, { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { SADefaultFlow } from '@chegg-wt/core/constants/site'
import { UserRoles } from '@chegg-wt/core/constants/user'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { loadCheggAuth } from '@chegg-wt/core/state/user/actions'
import {
  userRoleSelector,
  isAuthLoadingSelector,
} from '@chegg-wt/core/state/user/selectors'
import { LoadingDots } from '../LoadingDots'
import AuthLayout from './layout'
import { Props } from './types'
import * as Styled from './styled'
import { getValueProps } from './utils'

export const SuperAuthPage: FC<Props> = ({
  redirectTo,
  isLoading,
  defaultflow,
  client,
  loadCheggAuth,
  navigated,
  userRole,
  shouldShowSignupValueProps = false,
  hasFreeTrial,
  price,
  backgroundThroughGam = false,
}) => {
  const { toProfile } = useRoutesContext()

  useEffect(() => {
    if (userRole && userRole === UserRoles.NOT_LOGGED_IN) {
      const valueprop =
        shouldShowSignupValueProps && defaultflow === SADefaultFlow.SIGN_UP
          ? getValueProps(hasFreeTrial, price)
          : null
      loadCheggAuth(defaultflow, client, redirectTo, { valueprop })
    }
  }, [userRole])

  // Optimistically set to true as user is usually still fetching when page mounts.
  // If it turns out they are logged out then we will change value to false
  const [isAuthorizedOnEntry, setIsAuthorizedOnEntry] = useState(true)

  useEffect(() => {
    if (userRole && userRole === UserRoles.NOT_LOGGED_IN) {
      setIsAuthorizedOnEntry(false)
    } else if (userRole && isAuthorizedOnEntry) {
      navigated(toProfile())
    }
  }, [userRole])

  return (
    <AuthLayout backgroundThroughGam={backgroundThroughGam}>
      {isLoading && (
        <Styled.Loading>
          <LoadingDots />
        </Styled.Loading>
      )}
    </AuthLayout>
  )
}

const mapStateToProps = (state) => ({
  userRole: userRoleSelector(state),
  isLoading: isAuthLoadingSelector(state),
})

const mapDispatchToProps = {
  loadCheggAuth,
  navigated,
}

export default connect(mapStateToProps, mapDispatchToProps)(SuperAuthPage)
